import React, { useEffect } from "react";
import { Button, Drawer, Form, Input, Select, Space, Switch } from "antd";
import { AppstoreOutlined } from "@ant-design/icons";
import { SERVICE_CATEGORIES, formatEnumLabel } from "../constants";

export default function ServiceOfferingDrawer({
  open,
  onClose,
  onSubmit,
  loading,
  initialValues,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (open) {
      form.resetFields();
      if (initialValues) form.setFieldsValue(initialValues);
    }
  }, [open, form, initialValues]);

  const handleFinish = async (values) => {
    await onSubmit({ ...values, active: Boolean(values.active) });
  };

  return (
    <Drawer
      title={
        <Space>
          <span>
            {initialValues?.id ? "Edit Service Offering" : "Create Service Offering"}
          </span>
        </Space>
      }
      width={560}
      open={open}
      onClose={onClose}
      destroyOnClose
      placement="right"
      zIndex={2000}
      footer={
        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" loading={loading} onClick={() => form.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        initialValues={{ active: true }}
      >
        <Form.Item
          name="code"
          label="Code"
          rules={[{ required: true, message: "Code is required" }]}
        >
          <Input placeholder="UNIQUE_CODE" />
        </Form.Item>

        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: "Name is required" }]}
        >
          <Input placeholder="Service name" />
        </Form.Item>

        <Form.Item name="category" label="Category">
          <Select
            allowClear
            showSearch
            optionFilterProp="label"
            options={SERVICE_CATEGORIES.map((v) => ({
              value: v,
              label: formatEnumLabel(v),
            }))}
          />
        </Form.Item>

        <Form.Item name="description" label="Description">
          <Input.TextArea rows={3} />
        </Form.Item>

        <Form.Item name="active" label="Active" valuePropName="checked">
          <Switch />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
